<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>
<div class="container">
    <!-- <div class="top-bar">
        <div class="working">
            <a routerLink="/">
                <span class="logo">
                    <img src="assets/images/LTI-logo-white-v2.png" alt="" />
                </span>
            </a>
        </div>
    </div> -->
    <mat-card class="example-card nobg">
        <!-- <div class="top-bar" *ngIf="load">
            <div class="working">
                <p class="display-3">{{frequency}}</p>
            </div>
        </div> -->
        <mat-card-content class="p-0">
            <div class="main-content chart_main_content">
                <div class="right-outer-main w-100 mx-auto" [style]="!load?'display:none':''">
                    <div class="right-outer-main">
                        <div class="right-timer big-timer">

                            <div class="main-timer">
                                <div class="chart-outer">
                                    <canvas id="customtimer" class="big-timer">{{chart}}</canvas>
                                    <!-- <div class="flex gap-buttons">
                                        <button class="button-primary">
                                            <mat-icon>swap_horiz</mat-icon>
                                        </button>
                                        <button class="button-primary" (click)="rotateTxt()">
                                            <mat-icon>swap_vert</mat-icon>
                                        </button>
                                        <a class="button-primary" target="_blank" routerLink="/timer/{{activeTimer}}">
                                            <mat-icon>fullscreen</mat-icon>
                                        </a>
                                    </div> -->
                                </div>
                                <div class="chart_content_wrap" #container>

                                    <p class="main-time display-1 main_time_font_bold">{{ ("0" +
                                        (minutes<0?0:minutes)).slice(-2) }}:{{ ("0" + (seconds<0?0:seconds)).slice(-2)
                                            }}</p>

                                </div>
                            </div>


                            <div class="d-flex justify-content-center mt-40">
                                <button class="button-primary white w-25" [style.z-index]=9999 *ngIf="strtBtnLoader && timevalue>0"
                                    (click)="startimer()">
                                    <mat-spinner class="mx-auto" [diameter]="30"></mat-spinner>
                                </button>
                                <button class="button-primary white" [style.z-index]=9999
                                    *ngIf="timerPaused && !strtBtnLoader && (duration+lapsedOnStart>0 && timevalue>0)"
                                    (click)="startimer()">
                                    <mat-icon>play_arrow</mat-icon>
                                    Start timer
                                </button>
                                <button class="button-primary white" [style.z-index]=9999
                                    *ngIf="!timerPaused && !strtBtnLoader && (duration+lapsedOnStart>0  && timevalue>0)"
                                    (click)="pausetimer()">
                                    <mat-icon>pause</mat-icon>
                                    Pause timer
                                </button>
                                <button class="button-primary white" [style.z-index]=9999
                                    *ngIf="(duration+lapsedOnStart<=0 || timevalue<=0)"
                                    (click)="resetTimer(timerIndex)">
                                    <mat-icon>refresh</mat-icon>
                                    Reset timer
                                </button>
                                <div class="setTimer ms-2">
                                    <mat-form-field class="custom-input" [style.width.px]=80>
                                        <input type="number" [(ngModel)]="frminutes" matInput placeholder="Minutes" [min]="00" [max]="59" required>
                                    </mat-form-field>
                                    <span class="text-neutral-40">:</span>
                                    <mat-form-field class="custom-input" [style.width.px]=80>
                                        <input type="number" matInput [(ngModel)]="frseconds" placeholder="Seconds" [min]="00" [max]="59" required>
                                    </mat-form-field>
                                </div>
                                
                                <button class="button-primary white ms-2" [style.z-index]=9999 (click)="setTimerTime()"><mat-icon>alarm</mat-icon> Set
                                </button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>